var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-legend"},[_c('div',{staticClass:"chart-legend__color",style:({ backgroundColor: _vm.legend.color })}),_c('div',{staticClass:"chart-legend__label"},[_vm._v(" "+_vm._s(_vm.legend.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }